import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SwalComponent, SwalPortalTargets } from '@sweetalert2/ngx-sweetalert2';

@Component({
    selector: 'fe-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements AfterViewInit {
    @ViewChild('alertTemplate') alertTemplate!: SwalComponent;

    public optionsDefault: {
        showConfirm?: boolean;
        showCancel?: boolean;
        confirmText?: string;
        cancelText?: string;
        title?: string;
        subtitle?: string;
    } = {
        showConfirm: true,
        showCancel: true,
    };

    public options: {
        showConfirm?: boolean;
        showCancel?: boolean;
        confirmText?: string;
        cancelText?: string;
        title?: string;
        subtitle?: string;
    } = {};

    constructor(
        public readonly swalTargets: SwalPortalTargets,
        private translate: TranslateService,
    ) {}

    public ngAfterViewInit(): void {
        this.translate
            .get('fe_core_alert_confirm_button')
            .subscribe((value) => (this.optionsDefault.confirmText = value));
        this.translate
            .get('fe_core_alert_cancel_button')
            .subscribe((value) => (this.optionsDefault.cancelText = value));
        this.translate
            .get('fe_core_alert_title')
            .subscribe((value) => (this.optionsDefault.title = value));
        this.translate
            .get('fe_core_alert_subtitle')
            .subscribe((value) => (this.optionsDefault.subtitle = value));
    }

    public onClickCancel(): void {
        this.alertTemplate.close({
            isConfirmed: false,
            isDenied: false,
            isDismissed: true,
        });
    }

    public onClickConfirm(): void {
        this.alertTemplate.close({
            isConfirmed: true,
            isDenied: false,
            isDismissed: false,
        });
    }
}
